import hot from './hot.vue'

export default hot
